import { jsx as _jsx } from "react/jsx-runtime";
import { HubCardSkeleton } from "@cinch-nx/landing-ui-shared";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import { ArticleCard } from "../article-card/article-card";
import styles from "./articles-cards-list.module.css";
export const ArticlesCardsList = ({ articles , path , page  })=>{
    const { isFallback  } = useRouter();
    const { trackEvent  } = useAnalytics();
    const capitalPath = path.charAt(0).toUpperCase() + path.slice(1);
    const handleClick = (title)=>{
        trackEvent({
            eventName: `${capitalPath}- click article card`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "link",
                    label: title,
                    action: EventNames.click
                }
            }
        });
    };
    if (isFallback) {
        return /*#__PURE__*/ _jsx("div", {
            "data-testid": "skeletonPlaceHolder",
            children: Array.from({
                length: 10
            }).map((_, idx)=>/*#__PURE__*/ _jsx(HubCardSkeleton, {
                    featured: idx === 0,
                    hasDate: true
                }, idx))
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        children: articles === null || articles === void 0 ? void 0 : articles.map((item, idx)=>/*#__PURE__*/ _jsx("li", {
                className: styles["listItem"],
                children: /*#__PURE__*/ _jsx("a", {
                    href: item.path,
                    className: styles["link"],
                    "aria-label": item.title,
                    onClick: ()=>handleClick(item.title),
                    "data-testid": "article-sub-hub-preview-card",
                    children: /*#__PURE__*/ _jsx(ArticleCard, {
                        title: item.title,
                        image: item.image,
                        date: item.date,
                        featured: idx === 0 && page === 1
                    })
                })
            }, item.title))
    });
};
